<template>
  <div>

    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-4">
    </base-header>

    <div class="row">
      <div class="full__container">
        <div class="post" v-for="(media, index) in allMediaData">
          <div class="post__image">
            <img v-if="media.media_type !== 'VIDEO'" :src="media.media_url"/>
            <video v-if="media.media_type === 'VIDEO'" :src="media.media_url" controls style="height: 100%; width:100%">
            </video>
          </div>
          <div class="post__content">
            <div class="bottom__section">
              <article style="overflow: auto; max-height:300px !important;">
                {{ media.caption }}
              </article>

              <div class="date">{{ new Date(media.timestamp).toLocaleDateString() }} -
                {{ new Date(media.timestamp).toLocaleTimeString() }}
              </div>
              <div class="actions text-center">
                <div class="action like"><i class="fas fa-heart"> </i><span>{{ media.likes }}</span></div>
                <div class="action comment"><i class="far fa-comment-alt"></i><span>{{ media.comments }}</span></div>
              </div>
              <div class="row" style="margin-top: 5px">
                <div class="col text-center"><a :href="media.permalink" target="_blank">Link do Post</a></div>
              </div>
              <div class="row" style="margin-top: 5px">
                <div class="col text-center">
                  <a href="#!" class="btn btn-xl btn-primary"
                     @click.prevent="showModal(index)"
                  >Analytics</a>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!--      <div v-for="(media, index) in allMediaData" class="col-xl-12" style="max-height: 750px !important; margin: 35px !important;">-->
      <!--        <card header-classes="bg-transparent" >-->
      <!--          <div slot="header" class="row align-items-center">-->
      <!--            <div class="media align-items-center">-->
      <!--              <div class="media-body" style="margin: 20px">-->
      <!--                <h5 class="h3 mb-0" style="font-size:16px;" >Post {{index+1}}</h5>-->
      <!--                <h6 class="text-uppercase text-muted ls-1 mb-1">{{new Date(media.timestamp).toLocaleDateString()}} - {{new Date(media.timestamp).toLocaleTimeString()}}</h6>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--          <div class="row">-->
      <!--            <div class="col-6">-->
      <!--              <div class="content" style="height: 400px; overflow: auto; margin: 5px">-->
      <!--                <video v-if="media.media_type === 'VIDEO'" :src="media.media_url" controls style="width: 100%; height: 100%">-->
      <!--                  Your browser does not support the video tag.-->
      <!--                </video>-->
      <!--                <img v-if="media.media_type !== 'VIDEO'" :src="media.media_url" style="width: 100%; height: 100%"/>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="col-6">-->
      <!--              <div class="content" style="font-size: 14px">-->
      <!--                {{media.caption}}-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->

      <!--          <div class="card-footer text-muted">-->
      <!--            <div class="col text-center">-->

      <!--                <span class="description" >-->
      <!--                  <a :href="media.permalink" target="_blank">Link do Post</a>-->
      <!--                </span>-->
      <!--            </div>-->
      <!--            <div class="card-profile-stats d-flex justify-content-center mt-md-1">-->

      <!--              <div>-->
      <!--                <span class="heading">{{media.likes}}</span>-->
      <!--                <span class="description">Likes</span>-->
      <!--              </div>-->
      <!--              <div>-->
      <!--                <span class="heading">{{media.comments}}</span>-->
      <!--                <span class="description">Comentários</span>-->
      <!--              </div>-->
      <!--            </div>-->

      <!--            <div class="col text-center">-->
      <!--              <a href="#!" class="btn btn-xl btn-primary"-->
      <!--                 @click.prevent="showModal(index)"-->
      <!--              >Analytics</a>-->

      <!--            </div>-->

      <!--          </div>-->

      <!--        </card>-->
      <!--      </div>-->
    </div>

    <div class="container-fluid mt--7" v-if="!loaded" style="margin-top: 45px !important;">
      <div class="row">
        <div class="col-xl-12">
          <div class="row align-items-center">
            <loading :active="!loaded"
                     :can-cancel="true"
                     :on-cancel="onCancel"
                     :is-full-page="fullPage"/>
          </div>
        </div>
      </div>
    </div>
    <div>
      <!-- Modal Component -->
      <b-modal ref="my-modal" size='lg' ok-only title="Post Analytics">
        <div class="row">
          <div class="col-6">
            <stats-card id="stat-card-1" title="Alcance"
                        type="gradient-red"
                        v-bind:sub-title="allReachData[index]"
                        icon="ni ni-world-2"
                        class="mb-xl-4"
            >
            </stats-card>
            <b-tooltip target="stat-card-1"
                       title="Número total de contas únicas que viram o objeto de mídia"></b-tooltip>
          </div>

          <div class="col-6">
            <stats-card id="stat-card-2" title="Interações com o Post"
                        type="gradient-orange"
                        v-bind:sub-title="allImpressionsData[index]"
                        icon="ni ni-chart-bar-32"
                        class="mb-xl-4"
            >
            </stats-card>
            <b-tooltip target="stat-card-2"
                       title="Número total de vezes que o objeto de mídia teve interação com um usuário"></b-tooltip>
          </div>

          <!--          <div class="col-6">-->
          <!--            <stats-card id="stat-card-3" title="Engagement"-->
          <!--                        type="gradient
          -green"-->
          <!--                        v-bind:sub-title="allEngagementData[index]"-->
          <!--                        icon="ni ni-active-40"-->
          <!--                        class="mb-4 mb-xl-0"-->
          <!--            >-->
          <!--            </stats-card>-->
          <!--            <b-tooltip target="stat-card-3" title="Total number of likes and comments on the media object"></b-tooltip>-->

          <!--          </div>-->

          <div class="col-6">
            <stats-card id="stat-card-4" title="Salvos"
                        type="gradient-info"
                        v-bind:sub-title="allSavedData[index]"
                        icon="ni ni-book-bookmark"
                        class="mb-4 mb-xl-0"
            >
            </stats-card>
            <b-tooltip target="stat-card-4"
                       title="Número total de contas exclusivas que salvaram o objeto de mídia"></b-tooltip>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <base-progress type="success" :height="8"
                           :value="parseFloat(((allCombinedLikesComments[index]/currentFollowers)*100).toFixed(2))"
                           label="Taxa de Enganjamento"></base-progress>
          </div>
          <div class="col-6">
            <base-progress type="danger" :height="8"
                           :value="parseFloat(((allReachData[index]/currentFollowers)*100).toFixed(2))"
                           label="Taxa de alcance"></base-progress>
          </div>
        </div>


      </b-modal>
    </div>

  </div>
</template>
<script>
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue'
import BModalDirective from 'bootstrap-vue/es/directives/modal'
import Vue from 'vue'
import Store from "@/store/store";
import Loading from 'vue-loading-overlay';

Vue.use(BootstrapVue)
export default {
  directives: {
    'b-modal': BModalDirective
  },
  components: {
    Loading
  },
  data() {
    return {
      facebookToken: Store.state.accessToken,
      instagramID: process.env.VUE_APP_FACEBOOK_INSTAGRAM_ID,
      clientSecret: process.env.VUE_APP_FACEBOOK_CLIENT_SECRET,
      appId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
      mediaObjects: [],
      allImpressionsData: [],
      allEngagementData: [],
      allReachData: [],
      allSavedData: [],
      allReachRates: [],
      allMediaData: [],
      currentFollowers: 0,
      allCombinedLikesComments: [],
      index: null,
      loaded: false,
      fullPage: true,
    }
  },
  methods: {
    onCancel() {
    },
    getToken(fbToken, client_secret, app_id) {
      const self = this
      axios.get(`https://graph.facebook.com/v19.0/oauth/access_token?grant_type=fb_exchange_token&client_id=${app_id}&client_secret=${client_secret}&fb_exchange_token=${fbToken}`)
          .then(response => {
            this.facebookToken = response.data.access_token

          }).catch(error => {
            if (error.toString().includes("403") || error.toString().includes("400")){
              self.$store.commit('setUserName', "");
              self.$store.commit('setName', "");
              self.$store.commit('setAccessToken', "");
              self.$store.commit('setAuthentication', false);
              self.$router.push('/login');
            }
      })
    },
    fetchData(instaID, fbToken) {
      let self = this
      return new Promise(function (resolve, reject) {

        axios.get(`https://graph.facebook.com/v19.0/${instaID}/media?access_token=${fbToken}`)
            .then(response => {

              let sample = response.data.data

              for (let i = 0; i < sample.length; i++) {
                self.mediaObjects.push(sample[i].id)
              }
              for (let i = 0; i < self.mediaObjects.length; i++) {

                axios.get(`https://graph.facebook.com/v19.0/${self.mediaObjects[i]}/insights?metric=total_interactions&access_token=${fbToken}`)
                    .then(response => {

                      let sample = response.data.data

                      self.allImpressionsData.push(sample[0].values[0].value.toString())

                    }).catch(() => {

                })

                axios.get(`https://graph.facebook.com/v19.0/${self.mediaObjects[i]}/insights?metric=reach,saved&access_token=${fbToken}`)
                    .then(response => {

                      let sample = response.data.data

                      self.allReachData.push(sample[0].values[0].value.toString())
                      self.allSavedData.push(sample[1].values[0].value.toString())

                    }).catch(() => {

                })


              }

              //Get likes, comments, current followers
              axios.get(`https://graph.facebook.com/v19.0/${instaID}?fields=business_discovery.username(triciclo_retornamachine){followers_count,media_count,media{timestamp,caption,permalink,media_url,media_type,comments_count,like_count}}&access_token=${fbToken}`)
                  .then(response => {
                    let sample = response.data.business_discovery;
                    let currentFollowers = sample.followers_count;
                    self.currentFollowers = currentFollowers;

                    for (let i = 0; i < self.mediaObjects.length; i++) {
                      let post_metrics = sample.media.data[i]
                      let combined_likes_comments = post_metrics.comments_count + post_metrics.like_count
                      self.allCombinedLikesComments.push(combined_likes_comments)
                      self.allMediaData.push({
                        comments: post_metrics.comments_count,
                        likes: post_metrics.like_count,
                        timestamp: post_metrics.timestamp,
                        caption: post_metrics.caption,
                        permalink: post_metrics.permalink,
                        media_url: post_metrics.media_url,
                        media_type: post_metrics.media_type,
                      })
                    }

                    resolve()

                  }).catch(error => {
                  if (error.toString().includes("403")){
                    self.$store.commit('setUserName', "");
                    self.$store.commit('setName', "");
                    self.$store.commit('setAccessToken', "");
                    self.$store.commit('setAuthentication', false);
                    self.$router.push('/login');
                  }
              })

            }).catch(error => {
          if (error.toString().includes("403")){
            self.$store.commit('setUserName', "");
            self.$store.commit('setName', "");
            self.$store.commit('setAccessToken', "");
            self.$store.commit('setAuthentication', false);
            self.$router.push('/login');
          }
        })

      });
    },
    showModal(index) {
      this.index = index
      this.$refs['my-modal'].show()

    },
    closeModal() {
      this.$refs['my-modal'].hide()
    }
  },
  async mounted() {
    this.loaded = false;
    await this.getToken(this.facebookToken, this.clientSecret, this.appId);
    await this.fetchData(this.instagramID, this.facebookToken);
    this.loaded = true;
  }
}
</script>
<style>

.full__container {
  margin: 15px auto;
  display: block;
  max-width: 100%;
  columns: 4;
  column-gap: 20px;
  padding: 20px;
}

.full__container .post {
  width: 100%;
  display: block;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);
  margin: 0 0 20px;
  break-inside: avoid;
}

.full__container .post .post__image {
  height: 200px;
  position: relative;
}

.full__container .post .post__image::before {
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background: #000;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 30%);
  z-index: 2;
}

.full__container .post .post__image::after {
  content: "";
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: #000;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 100%);
  z-index: 2;
}

.full__container .post .post__image img {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  object-position: center;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.full__container .post .post__image .social__media_icon {
  position: absolute;
  top: 15px;
  left: 15px;
  display: block;
  width: 20px;
  height: 20px;
  overflow: hidden;
  z-index: 3;
}

.full__container .post .post__image .social__media_icon i {
  color: #fff;
  font-size: 1.1rem;
}

.full__container .post .post__content {
  padding: 15px;
}

.full__container .post .post__content .top__section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0.2rem 0 1.4rem;
}

.full__container .post .post__content .top__section .profile__img {
  display: block;
  overflow: hidden;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  position: relative;
  border: 1px solid #3498db;
}

.full__container .post .post__content .top__section .profile__img img {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.full__container .post .post__content .top__section h3, .full__container .post .post__content .top__section span {
  margin: 0 0 0 0.5rem;
}

.full__container .post .post__content .top__section h3 {
  font-size: 1.2rem;
  margin: 0 0 0 0.5rem;
  color: #353535;
}

.full__container .post .post__content .top__section span {
  color: rgba(53, 53, 53, 0.7);
  font-size: 0.9rem;
}

.full__container .post .post__content .bottom__section article {
  text-transform: capitalize;
  font-size: 0.8rem;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.9);
}

.full__container .post .post__content .bottom__section article .hashtag {
  color: #00bcd4;
  font-weight: 500;
}

.full__container .post .post__content .bottom__section .hashtags {
  list-style: none;
  margin: 0.8rem 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}

.full__container .post .post__content .bottom__section .hashtags li {
  font-size: 0.8rem;
  margin: 0 0.2rem;
  color: #00bcd4;
  font-weight: 700;
}

.full__container .post .post__content .bottom__section .date {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.8rem;
  padding: 0.2rem 0 0.7rem;
}

.full__container .post .post__content .bottom__section .actions {
  display: flex;
}

.full__container .post .post__content .bottom__section .actions .action {
  display: flex;
  align-items: center;
  margin: 0 0.7rem 0 0;
}

.full__container .post .post__content .bottom__section .actions .action i {
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.8rem;
}

.full__container .post .post__content .bottom__section .actions .action span {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.8rem;
  margin: 0 0 0 0.3rem;
}

@media screen and (max-width: 1200px) {
  .full__container {
    columns: 4;
  }
}

@media screen and (max-width: 992px) {
  .full__container {
    columns: 3;
  }
}

@media screen and (max-width: 768px) {
  .full__container {
    columns: 2;
  }
}

@media screen and (max-width: 480px) {
  .full__container {
    columns: 1;
  }
}

</style>
